import React, { useState, useEffect } from 'react';
import { Box, Typography, Card, CardContent } from '@mui/material';
import { motion, AnimatePresence } from 'framer-motion';
import { FaFileMedical, FaBook } from 'react-icons/fa';
import { GiMeditation } from 'react-icons/gi';

const featuresData = [
  {
    icon: <FaFileMedical />,
    title: 'Log Dream',
    desc: 'Document your dreams and receive insightful AI interpretations customized to you.',
  },
  {
    icon: <FaBook />,
    title: 'Dream Diary',
    desc: 'Track your dream patterns over time and uncover recurring themes.',
  },
  {
    icon: <GiMeditation />,
    title: 'Meditation',
    desc: 'Experience curated or custom mindfulness sessions to balance your day.',
  },
];

const FeatureSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Automatic slideshow
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % featuresData.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <Box sx={{ py: 10 }}>
      <Typography variant="h3" align="center" sx={{ mb: 4 }}>
        Powerful Features
      </Typography>
      <Box display="flex" justifyContent="center" alignItems="center">
        <Box sx={{ width: 400, overflow: 'hidden' }}>
          <AnimatePresence mode="wait">
            {featuresData.map((feat, i) =>
              i === currentIndex ? (
                <motion.div
                  key={i}
                  initial={{ x: 100, opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  exit={{ x: -100, opacity: 0 }}
                  transition={{ type: 'slide', stiffness: 500 }}
                  style={{ textAlign: 'center' }}
                >
                  <Card
                    sx={{
                      minHeight: 280,
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      p: 3,
                      mb: 2,
                    }}
                    elevation={3}
                  >
                    <Box sx={{ fontSize: 64, color: 'primary.main', mb: 2 }}>
                      {feat.icon}
                    </Box>
                    <CardContent>
                      <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>
                        {feat.title}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {feat.desc}
                      </Typography>
                    </CardContent>
                  </Card>
                </motion.div>
              ) : null
            )}
          </AnimatePresence>
        </Box>
      </Box>
      {/* Dots for navigation */}
      <Box display="flex" justifyContent="center" sx={{ mt: 2 }}>
        {featuresData.map((_, index) => (
          <Box
            key={index}
            onClick={() => setCurrentIndex(index)}
            sx={{
              width: 10,
              height: 10,
              borderRadius: '50%',
              backgroundColor: index === currentIndex ? 'primary.main' : 'grey.400',
              mx: 1,
              cursor: 'pointer',
            }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default FeatureSection;
